import templateUrl from "emun.auth/permissions/role-permissions-editor.htm";
import ServiceBusController from "servicestack/service-bus.controller";
import groupBy from "lodash/groupBy";
import $resolve from "ng";

export class RolePermissionsFieldsetController extends ServiceBusController {
  $onInit() {
    this.request = {};
    this.bus.read("GetRolePermissions.json").then(r => (this.request = r.data));
    this.bus
      .read("QueryPermissions.json")
      .then(r => (this.permissions = groupBy(r.data.results, "groupName")));
    this.bus.read("QueryRoles.json").then(r => (this.roles = r.data.results));
  }
  submit() {
    this.bus.send("SaveRolePermissions.json", this.request).then(r => {
      const $notify = $resolve("notify");
      $notify.success("Your changes where successfully saved", {
        title: "Success!",
        ttl: 5000
      });
    });
  }
}

export default {
  bindings: {
    // request: "<ngModel",
    // bus: "<"
  },
  controller: RolePermissionsFieldsetController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};
